import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Section, SectionTitle, InputGroup, InputWrapper, Label, Select } from '../AdvancedSearchBuilder.styled';

const VehicleSection = ({
  vehicle,
  vendors,
  models,
  years,
  versions,
  fitments,
  loadingVendors,
  loadingModels,
  loadingYears,
  loadingVersions,
  loadingFitments,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <Section>
      <SectionTitle>{t('searchByVehicleModel')}</SectionTitle>
      <InputGroup>
        <InputWrapper>
          <Label>{t('vehicleBrand')}</Label>
          <Select
            value={vehicle.vendor}
            onChange={(e) => onChange('vehicleVendor', e.target.value)}
            disabled={loadingVendors}
          >
            <option value="">
              {loadingVendors ? '...' : t('selectBrand')}
            </option>
            {vendors.map((v) => (
              <option key={v.value} value={v.value}>
                {v.label}
              </option>
            ))}
          </Select>
        </InputWrapper>

        <InputWrapper>
          <Label>{t('vehicleModel')}</Label>
          <Select
            value={vehicle.model}
            onChange={(e) => onChange('vehicleModel', e.target.value)}
            disabled={!vehicle.vendor || loadingModels}
          >
            <option value="">
              {loadingModels ? '...' : t('selectModel')}
            </option>
            {models.map((m) => (
              <option key={m.value} value={m.value}>
                {m.label}
              </option>
            ))}
          </Select>
        </InputWrapper>

        <InputWrapper>
          <Label>{t('year')}</Label>
          <Select
            value={vehicle.year}
            onChange={(e) => onChange('vehicleYear', e.target.value)}
            disabled={!vehicle.model || loadingYears}
          >
            <option value="">
              {loadingYears ? '...' : t('selectYear')}
            </option>
            {years.map((y) => (
              <option key={y.value} value={y.value}>
                {y.label}
              </option>
            ))}
          </Select>
        </InputWrapper>

        <InputWrapper>
          <Label>{t('version')}</Label>
          <Select
            value={vehicle.version}
            onChange={(e) => onChange('vehicleVersion', e.target.value)}
            disabled={!vehicle.year || loadingVersions}
          >
            <option value="">
              {loadingVersions ? '...' : t('selectVersion')}
            </option>
            {versions.map((v) => (
              <option key={v.value} value={v.value}>
                {v.label}
              </option>
            ))}
          </Select>
        </InputWrapper>

        <InputWrapper>
          <Label>{t('fitment')}</Label>
          <Select
            value={vehicle.fitment}
            onChange={(e) => onChange('vehicleFitment', e.target.value)}
            disabled={!vehicle.version || loadingFitments}
          >
            <option value="">
              {loadingFitments ? '...' : t('selectFitment')}
            </option>
            {fitments.map((f) => (
              <option key={f.value} value={f.value}>
                {f.label}
              </option>
            ))}
          </Select>
        </InputWrapper>
      </InputGroup>
    </Section>
  );
};

VehicleSection.propTypes = {
  vehicle: PropTypes.shape({
    vendor: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.string,
    version: PropTypes.string,
    fitment: PropTypes.string,
  }).isRequired,
  vendors: PropTypes.array,
  models: PropTypes.array,
  years: PropTypes.array,
  versions: PropTypes.array,
  fitments: PropTypes.array,
  loadingVendors: PropTypes.bool,
  loadingModels: PropTypes.bool,
  loadingYears: PropTypes.bool,
  loadingVersions: PropTypes.bool,
  loadingFitments: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

VehicleSection.defaultProps = {
  vendors: [],
  models: [],
  years: [],
  versions: [],
  fitments: [],
  loadingVendors: false,
  loadingModels: false,
  loadingYears: false,
  loadingVersions: false,
  loadingFitments: false,
};

export default VehicleSection;
